import { createContext } from 'react'
import { ApiClientV1 } from '../api'
import { setPlatformGlobals } from '../globals'

export const ApiClientContext = createContext<ApiClientV1 | null>(null)

// TODO: Remove this once everything is being consumed from HorizonContext
setPlatformGlobals({ ApiClientContext })

export const ApiClientContextProvider = ApiClientContext.Provider
